import { createSelector } from "reselect";

const getStory = (state) => state.story;
const getSlideId = (state, ownProps) => ownProps.slideId;

export const getSlideshowChapterFromSlideId = createSelector(
  getStory,
  getSlideId,
  (story, slideId) => {
    const slideEntity = story.entities.slide[slideId];

    const slideshowLink = story.chapters.find((chapter) => {
      const chapterLink = story.entities[chapter.schema][chapter.id];
      return (
        chapterLink.type === "slideshow" &&
        chapterLink.slides.includes(slideEntity.id)
      );
    });

    if (!slideshowLink || slideshowLink.schema !== "slideshowChapter") {
      throw new Error("Could not find slideshow from slide");
    }

    return story.entities[slideshowLink.schema][slideshowLink.id];
  },
);

export const makeGetSlideshowChapterFromSlideId = () =>
  getSlideshowChapterFromSlideId;
